import React, { useContext } from 'react';
import useStyles from '@front10/helpers/dist/UseStyles';
import { Context } from '@front10/helpers/dist/Context';

import Box from '../../../elements/Box';
import Text from '../../../elements/Text';

const FareItemInfo = (props) => {
  const { translate, direction, theme } = useContext(Context);
  const [className, style] = useStyles(props, { direction, theme });

  return (
    <Box className={`fare-car-class-type ${className}`} style={style}>
      <Text {...props?.infoStyle}>{translate('cmp-text-info', 'Text Info')}</Text>
    </Box>
  );
};

FareItemInfo.componentName = 'FareItemInfo';

export default FareItemInfo;
